module.exports = __webpack_public_path__ + "static/media/shortcut-icon.50e91ad0.png";